import { render, staticRenderFns } from "./DropzoneFileUploadObs.vue?vue&type=template&id=4c5b0c5a&scoped=true"
import script from "./DropzoneFileUploadObs.vue?vue&type=script&lang=js"
export * from "./DropzoneFileUploadObs.vue?vue&type=script&lang=js"
import style0 from "./DropzoneFileUploadObs.vue?vue&type=style&index=0&id=4c5b0c5a&prod&lang=css"
import style1 from "./DropzoneFileUploadObs.vue?vue&type=style&index=1&id=4c5b0c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b0c5a",
  null
  
)

export default component.exports